
import { BusinessEventType } from "@reef-os/utils/enums/businessEventType"
import { EventStatus } from "@reef-os/utils/enums/eventStatus"
import moment from "moment"
import "moment-timezone"

function convertToLocalTime(date, time, timezone) {
    if (date && time) {
        return moment.utc(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss")
            .tz(timezone)
            .format("HH:mm:ss")
    }
    return null
}

function convertToLocalDate(date, time, timezone) {
    if (date && time) {
        return moment.utc(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss")
            .tz(timezone)
            .format("YYYY-MM-DD")
    } else if (date) {
        return date
    }
    return null
}

export default class EventModel {
    constructor(event, restaurant, business) {
        let timezone = business &&
            business.timezone
            ? business.timezone
            : ""
        this.description = event.description
        this.name = event.name
        this.id = event.id
        this.status = event.status
        this.type = event.type
        this.start_date = convertToLocalDate(event.start_date, event.start_time, timezone)
        this.end_date = convertToLocalDate(event.end_date, event.end_time, timezone)
        this.start_time = convertToLocalTime(event.start_date, event.start_time, timezone)
        this.end_time = convertToLocalTime(event.end_date, event.end_time, timezone)
        this.pre_order_end_time = convertToLocalTime(event.pre_order_end_date, event.pre_order_end_time, timezone)
        this.pre_order_end_date = convertToLocalDate(event.pre_order_end_date, event.pre_order_end_time, timezone)
        this.restaurantName =
            restaurant && restaurant.name ? restaurant.name : ""
        this.restaurant_id = event.restaurant_id
        if (event.image) {
            const filenameArr = event.image.split(".")
            const sizedFileName = filenameArr[0] + "_" + "1500x550." + filenameArr[1]
            this.image = `${process.env.VUE_APP_BASE_EVENT_IMAGE_URL}${business.slug}/${sizedFileName}`
        } else {
            this.image = "/images/event-banner-placeholder.jpg"
        }
        this.isUpcoming = event.status == EventStatus.ONGOING || event.status == EventStatus.PREORDER

        if (this.type == BusinessEventType.VIRTUAL) {
            const endDate = this.end_date
                ? this.end_date
                : this.start_date
            this.eventDate = moment(
                `${endDate} ${this.end_time}`,
                "YYYY-MM-DD HH:mm:ss"
            ).format("MMMM Do h:mm a")
            this.startTimestamp = moment(
                `${endDate} ${this.end_time}`,
                "YYYY-MM-DD HH:mm:ss"
            ).unix()
        } else {
            const start = moment(
                `${this.start_date} ${this.start_time}`,
                "YYYY-MM-DD HH:mm:ss"
            ).format("MMMM Do h:mm a")
            if (this.end_date) {
                const end = moment(
                    `${this.end_date} ${this.end_time}`,
                    "YYYY-MM-DD HH:mm:ss"
                ).format("MMMM Do h:mm a")
                this.eventDate = `${start} - ${end}`
            } else {
                const endTime = moment(
                    this.end_time,
                    "HH:mm:ss"
                ).format("h:mm a")
                this.eventDate = `${start} - ${endTime}`
            }
            this.startTimestamp = moment(
                `${event.start_date} ${this.start_time}`,
                "YYYY-MM-DD HH:mm:ss"
            ).unix()
        }
    }
}